import script from "./SiteClock.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteClock.vue?vue&type=script&setup=true&lang=js"

import "./SiteClock.vue?vue&type=style&index=0&id=30cce715&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30cce715"]])

export default __exports__